import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d3ab03f")

_pushScopeId("data-v-3d3ab03f")
const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "row p-2" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Emisor")
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Razón social", -1)
const _hoisted_8 = { class: "contenidoInfoDetalle" }
const _hoisted_9 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Unidad de negocio", -1)
const _hoisted_11 = { class: "contenidoInfoDetalle" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Fechas", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Fecha solicitud", -1)
const _hoisted_15 = { class: "contenidoInfoDetalle" }
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Fecha propuesta", -1)
const _hoisted_19 = { class: "d-block subtituloInfoDetalle" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "row p-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-8" }, [
    /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Beneficiario")
  ])
], -1)
const _hoisted_21 = { class: "row p-2" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Nombre del beneficiario", -1)
const _hoisted_24 = { class: "contenidoInfoDetalle" }
const _hoisted_25 = { class: "col-md-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Solicitud", -1)
const _hoisted_27 = { class: "contenidoInfoDetalle" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Notificación de pago:"),
  /*#__PURE__*/_createVNode("small", { class: "contenidoInfoDetalle" })
], -1)
const _hoisted_29 = { class: "row p-2" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Tipo de pago", -1)
const _hoisted_32 = { class: "contenidoInfoDetalle" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Importe", -1)
const _hoisted_35 = { class: "contenidoInfoDetalle" }
const _hoisted_36 = { class: "row p-2" }
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Formas de pago", -1)
const _hoisted_39 = {
  key: 0,
  class: "contenidoInfoDetalle"
}
const _hoisted_40 = {
  key: 1,
  class: "contenidoInfoDetalle"
}
const _hoisted_41 = {
  key: 2,
  class: "contenidoInfoDetalle"
}
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Tipo de gasto", -1)
const _hoisted_44 = { class: "contenidoInfoDetalle" }
const _hoisted_45 = { class: "col-md-3" }
const _hoisted_46 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Rubro de presupuesto", -1)
const _hoisted_47 = { class: "contenidoInfoDetalle" }
const _hoisted_48 = { class: "col-md-1" }
const _hoisted_49 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Código Control", -1)
const _hoisted_50 = { class: "contenidoInfoDetalle" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "row p-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-8" }, [
    /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Datos de cuenta bancaria")
  ])
], -1)
const _hoisted_52 = { class: "row p-2" }
const _hoisted_53 = { class: "col-md-3" }
const _hoisted_54 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Banco", -1)
const _hoisted_55 = { class: "contenidoInfoDetalle" }
const _hoisted_56 = { class: "col-md-3" }
const _hoisted_57 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Cuenta", -1)
const _hoisted_58 = { class: "contenidoInfoDetalle" }
const _hoisted_59 = { class: "col-md-3" }
const _hoisted_60 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "CLABE", -1)
const _hoisted_61 = { class: "contenidoInfoDetalle" }
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "RFC", -1)
const _hoisted_64 = { class: "contenidoInfoDetalle" }
const _hoisted_65 = { class: "row p-2" }
const _hoisted_66 = { class: "col-md-3" }
const _hoisted_67 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "No. Convenio/ Servicio de pago", -1)
const _hoisted_68 = { class: "contenidoInfoDetalle" }
const _hoisted_69 = { class: "col-md-3" }
const _hoisted_70 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Referencia", -1)
const _hoisted_71 = { class: "contenidoInfoDetalle" }
const _hoisted_72 = { class: "col-md-3" }
const _hoisted_73 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Divisa", -1)
const _hoisted_74 = {
  key: 0,
  class: "contenidoInfoDetalle"
}
const _hoisted_75 = {
  key: 1,
  class: "contenidoInfoDetalle"
}
const _hoisted_76 = {
  key: 2,
  class: "contenidoInfoDetalle"
}
const _hoisted_77 = { class: "col-md-3" }
const _hoisted_78 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Concepto de pago", -1)
const _hoisted_79 = { class: "contenidoInfoDetalle" }
const _hoisted_80 = { class: "row p-2" }
const _hoisted_81 = { class: "col-md-4" }
const _hoisted_82 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Observaciones", -1)
const _hoisted_83 = { class: "contenidoInfoDetalle" }
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "row p-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-8" }, [
    /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Archivos adjuntos")
  ])
], -1)
const _hoisted_85 = { class: "row p-2" }
const _hoisted_86 = { class: "col-md-4" }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_89 = { id: "archivoMostrado" }
const _hoisted_90 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_91 = {
  class: "modal-dialog modal-xl",
  style: {"height":"70vh"}
}
const _hoisted_92 = { class: "modal-content" }
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Documento")
], -1)
const _hoisted_94 = { class: "modal-body" }
const _hoisted_95 = { class: "modal-footer" }
const _hoisted_96 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Cerrar", -1)
const _hoisted_97 = { class: "col-md-3" }
const _hoisted_98 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "No. Factura", -1)
const _hoisted_99 = { class: "contenidoInfoDetalle" }
const _hoisted_100 = { class: "col-md-3" }
const _hoisted_101 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "UUID", -1)
const _hoisted_102 = { class: "contenidoInfoDetalle" }
const _hoisted_103 = { class: "modal-dialog modal-xl" }
const _hoisted_104 = { class: "modal-content" }
const _hoisted_105 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Soportes de requisición"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_106 = { class: "modal-body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ModalSoporte = _resolveComponent("ModalSoporte")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("small", _hoisted_8, _toDisplayString(_ctx.razonSocial), 1)
          ]),
          (_ctx.unidadNegocio != '')
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("small", _hoisted_11, _toDisplayString(_ctx.unidadNegocio), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createVNode("small", _hoisted_15, _toDisplayString(_ctx.DarFormatoFecha(_ctx.fechaSolicitud)), 1)
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _hoisted_18,
        _createVNode("small", _hoisted_19, _toDisplayString(_ctx.DarFormatoFecha(_ctx.fechaPropuesta)), 1)
      ])
    ]),
    _hoisted_20,
    _createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode("small", _hoisted_24, _toDisplayString(_ctx.nombreBeneficiario), 1)
      ]),
      _createVNode("div", _hoisted_25, [
        _hoisted_26,
        _createVNode("small", _hoisted_27, _toDisplayString(_ctx.tipoRequisicion), 1)
      ]),
      _hoisted_28
    ]),
    _createVNode("div", _hoisted_29, [
      _createVNode("div", _hoisted_30, [
        _hoisted_31,
        _createVNode("small", _hoisted_32, _toDisplayString(_ctx.tipoPago), 1)
      ]),
      _createVNode("div", _hoisted_33, [
        _hoisted_34,
        _createVNode("small", _hoisted_35, [
          _createVNode("strong", null, " $ " + _toDisplayString(_ctx.formatearImporte(_ctx.importe)), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_36, [
      _createVNode("div", _hoisted_37, [
        _hoisted_38,
        (_ctx.medioInstruccion == 1)
          ? (_openBlock(), _createBlock("small", _hoisted_39, "Transferencia"))
          : _createCommentVNode("", true),
        (_ctx.medioInstruccion == 2)
          ? (_openBlock(), _createBlock("small", _hoisted_40, "Cheque simple"))
          : _createCommentVNode("", true),
        (_ctx.medioInstruccion == 3)
          ? (_openBlock(), _createBlock("small", _hoisted_41, "Cheque certificado"))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_42, [
        _hoisted_43,
        _createVNode("small", _hoisted_44, _toDisplayString(_ctx.nombreTipoGasto), 1)
      ]),
      _createVNode("div", _hoisted_45, [
        _hoisted_46,
        _createVNode("small", _hoisted_47, _toDisplayString(_ctx.nombreRubro), 1)
      ]),
      _createVNode("div", _hoisted_48, [
        _hoisted_49,
        _createVNode("small", _hoisted_50, _toDisplayString(_ctx.claveCodigo), 1)
      ])
    ]),
    _hoisted_51,
    _createVNode("div", _hoisted_52, [
      _createVNode("div", _hoisted_53, [
        _hoisted_54,
        _createVNode("small", _hoisted_55, _toDisplayString(_ctx.bancoBeneficiario), 1)
      ]),
      _createVNode("div", _hoisted_56, [
        _hoisted_57,
        _createVNode("small", _hoisted_58, _toDisplayString(_ctx.cuentaBeneficiario), 1)
      ]),
      _createVNode("div", _hoisted_59, [
        _hoisted_60,
        _createVNode("small", _hoisted_61, _toDisplayString(_ctx.clabe), 1)
      ]),
      _createVNode("div", _hoisted_62, [
        _hoisted_63,
        _createVNode("small", _hoisted_64, _toDisplayString(_ctx.rfcBeneficiario), 1)
      ])
    ]),
    _createVNode("div", _hoisted_65, [
      _createVNode("div", _hoisted_66, [
        _hoisted_67,
        _createVNode("small", _hoisted_68, _toDisplayString(_ctx.convenioServicioPago), 1)
      ]),
      _createVNode("div", _hoisted_69, [
        _hoisted_70,
        _createVNode("small", _hoisted_71, _toDisplayString(_ctx.referencia), 1)
      ]),
      _createVNode("div", _hoisted_72, [
        _hoisted_73,
        (_ctx.divisa == 1)
          ? (_openBlock(), _createBlock("small", _hoisted_74, "Peso"))
          : (_ctx.divisa == 2)
            ? (_openBlock(), _createBlock("small", _hoisted_75, "Dolar"))
            : (_ctx.divisa == 3)
              ? (_openBlock(), _createBlock("small", _hoisted_76, "Euro "))
              : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_77, [
        _hoisted_78,
        _createVNode("small", _hoisted_79, _toDisplayString(_ctx.conceptoPagos), 1)
      ])
    ]),
    _createVNode("div", _hoisted_80, [
      _createVNode("div", _hoisted_81, [
        _hoisted_82,
        _createVNode("small", _hoisted_83, _toDisplayString(_ctx.observacionInstruccion), 1)
      ])
    ]),
    _hoisted_84,
    _createVNode("div", _hoisted_85, [
      _createVNode("div", _hoisted_86, [
        (_ctx.rolUsuario == 'Verificador CXP' || _ctx.rolUsuario == 'Autorizador CXP')
          ? (_openBlock(), _createBlock("i", {
              key: 0,
              class: "fas fa-file-alt",
              "data-bs-toggle": "modal",
              "data-bs-target": '#' + 'modalSoporte' + _ctx.componenteId,
              style: {"cursor":"pointer","font-size":"24px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.EsconderBackdrop && _ctx.EsconderBackdrop(...args)))
            }, null, 8, ["data-bs-target"]))
          : _createCommentVNode("", true),
        (_ctx.rolUsuario != 'Autorizador CXP' && _ctx.rolUsuario != 'Verificador CXP')
          ? (_openBlock(), _createBlock("div", _hoisted_87, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentos, (documento, index) => {
                return (_openBlock(), _createBlock("small", {
                  class: "contenidoInfoDetalle archivoInfoDetalle d-block",
                  key: documento.ruta
                }, [
                  _hoisted_88,
                  _createVNode("p", _hoisted_89, "Archivo " + _toDisplayString(index + 1), 1),
                  _hoisted_90,
                  (documento.tipoDocumento == 'PDF')
                    ? (_openBlock(), _createBlock("u", {
                        key: 0,
                        "data-bs-toggle": "modal",
                        "data-bs-target": '#' + _ctx.componenteId + 'modalDocumento',
                        ref: "ligaModal",
                        onClick: ($event: any) => (_ctx.MostrarArchivo(documento.documentoRequisicionPagoId, documento.tipoDocumento))
                      }, _toDisplayString(documento.ruta.toLowerCase()), 9, ["data-bs-target", "onClick"]))
                    : _createCommentVNode("", true),
                  (documento.tipoDocumento != 'PDF')
                    ? (_openBlock(), _createBlock("u", {
                        key: 1,
                        "data-bs-toggle": "modal",
                        "data-bs-target": "",
                        ref: "ligaModal",
                        onClick: ($event: any) => (_ctx.MostrarArchivo(documento.documentoRequisicionPagoId, documento.tipoDocumento))
                      }, _toDisplayString(documento.ruta.toLowerCase()), 9, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: "modal fade",
          id: _ctx.componenteId + 'modalDocumento',
          tabindex: "-1",
          "aria-hidden": "true",
          "data-backdrop": "false"
        }, [
          _createVNode("div", _hoisted_91, [
            _createVNode("div", _hoisted_92, [
              _hoisted_93,
              _createVNode("div", _hoisted_94, [
                _createVNode("iframe", {
                  id: "iFrameDocumentosUno",
                  name: "iFrameDocumentosUno",
                  src: _ctx.rutaDocumento,
                  width: "100%",
                  style: {"height":"50vh"}
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_95, [
                _hoisted_96,
                _createVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.DescargaPDF())),
                  type: "button",
                  class: "btn btn-primary",
                  style: {"color":"white"}
                }, " Descargar ")
              ])
            ])
          ])
        ], 8, ["id"])
      ]),
      _createVNode("div", _hoisted_97, [
        _hoisted_98,
        _createVNode("small", _hoisted_99, _toDisplayString(_ctx.numeroFactura), 1)
      ]),
      _createVNode("div", _hoisted_100, [
        _hoisted_101,
        _createVNode("small", _hoisted_102, _toDisplayString(_ctx.uuid), 1)
      ])
    ]),
    _createVNode("div", {
      class: "modal fade",
      id: 'modalSoporte' + _ctx.componenteId,
      tabindex: "-1"
    }, [
      _createVNode("div", _hoisted_103, [
        _createVNode("div", _hoisted_104, [
          _hoisted_105,
          _createVNode("div", _hoisted_106, [
            _createVNode(_component_ModalSoporte, {
              requisicion_id: _ctx.requisicionPagoId,
              componenteId: _ctx.componenteId
            }, null, 8, ["requisicion_id", "componenteId"])
          ])
        ])
      ])
    ], 8, ["id"])
  ]))
})